import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import moment from 'moment';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { DateRangePicker } from "react-dates";

import Checkbox from "@material-ui/core/Checkbox";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import Close from "@material-ui/icons/Close";
import Check from "@material-ui/icons/Check";

import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Table from "../../components/Table/Table";
import Button from "../../components/CustomButtons/Button";

import style from "../../assets/jss/material-kit-pro-react/views/componentsSections/contentAreas";

import { blockServiceDates } from "../../actions/ownersActions";
import formatPrice from "../../utils/formatPrice";

function Transition(props) {
    return <Slide direction="down" {...props} />;
}

class SectionTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: [],
            noticeModal: false,
            startDate: null,
            endDate: null,
            actualService: {
                rooms: []
            }
        };
    }

    handleToggle = value => {
        const { checked } = this.state;
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];
        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        this.setState({ checked: newChecked });
    };

    handleClickOpen = (modal, serviceId, serviceType, serviceName, rooms=[]) => {
        let x = [];
        x[modal] = true;
        x['actualService'] = {_id: serviceId, type:serviceType, name: serviceName, rooms};
        this.setState(x);
    };

    handleClose = modal => {
        let x = [];
        x[modal] = false;
        x['actualService'] = {rooms:[]};
        x['startDate'] = null;
        x['endDate'] = null;
        x['checked'] = [];
        this.setState(x);
    };

    blockDates = () => {
        const { actualService, startDate, endDate, checked } = this.state;

        if (startDate !== null && endDate !== null) {
            let serviceInfo = {
                _id: actualService._id,
                type: actualService.type,
                start: moment(startDate).format("DD/MM/YYYY"),
                end: moment(endDate).format("DD/MM/YYYY"),
                blockedByOwner: true
            };

            // TODO: Añadir la validación para tours

            if (actualService.type === 'accommodation') {

                if (actualService.rooms.length > 0) {
                    serviceInfo.full_lease = false;

                    if (checked.length > 0) {
                        let roomsIds = checked.map(ch => {
                            return actualService.rooms[ch]._id;
                        });

                        serviceInfo.rooms = roomsIds;

                        this.props.blockServiceDates(serviceInfo);
                        this.handleClose("noticeModal");
                    } else {
                        alert('Por favor selecciona la(s) habitación(es) a bloquear');
                    }
                } else {
                    serviceInfo.full_lease = true;

                    this.props.blockServiceDates(serviceInfo);
                    this.handleClose("noticeModal");
                }
            }

        } else {
            alert('Por favor ingresa fechas de Inicio y Fin');
        }
    };

    render() {
        const { serviceType, tableContent, classes
            // , ...rest
        } = this.props;

        const tableData = [];
        if (tableContent.length > 0) {
            if (serviceType === "accommodations") {
                tableContent.map(tc => {
                    tableData.push([
                        <b>{tc.name}</b>,
                        `${tc.location.address}, ${tc.location.city.name} (${tc.location.department.name})`,
                        tc.full_lease ? "Se reserva completamente" : "Reserva por habitaciones",
                        <Button color="success" onClick={() => this.handleClickOpen("noticeModal", tc._id, 'accommodation', tc.name, tc.rooms)}>
                            Bloquear fechas
                        </Button>
                    ]);
                })
            } else {
                tableContent.map(tc => {
                    tableData.push([
                        <b>{tc.name}</b>,
                        `${tc.location.city.name} (${tc.location.department.name})`,
                        `${formatPrice(tc.pricing.low_season)} - ${formatPrice(tc.pricing.high_season)}`,
                        <Button color="success" onClick={() => this.handleClickOpen("noticeModal", tc._id, 'tour', tc.name)}>
                            Bloquear fechas
                        </Button>
                    ]);
                })
            }
        } else {
            tableData.push(["No hay información para mostrar", "", "", ""]);
        }

        return (
            <div className="cd-section" id="contentAreas">
            {/*<div {...rest} className="cd-section" id="contentAreas">*/}
                <div id="tables">
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12} lg={12} className={`${classes.mrAuto} ${classes.mlAuto}`}>
                            <h4>
                                <small>Mis {serviceType === 'accommodations'
                                    ? 'Alojamientos'
                                    : serviceType === 'tours'
                                        ? 'Tours'
                                        : null}
                                </small>
                            </h4>

                            {/* NOTICE MODAL START */}
                            <Dialog
                                classes={{ root: classes.modalRoot, paper: classes.modal }}
                                open={this.state.noticeModal}
                                TransitionComponent={Transition}
                                keepMounted
                                onClose={() => this.handleClose("noticeModal")}
                                aria-labelledby="notice-modal-slide-title"
                                aria-describedby="notice-modal-slide-description"
                            >
                                <DialogTitle id="notice-modal-slide-title" disableTypography className={classes.modalHeader}>
                                    <Button
                                        simple
                                        className={classes.modalCloseButton}
                                        key="close"
                                        aria-label="Close"
                                        onClick={() => this.handleClose("noticeModal")}
                                    >
                                        {" "}
                                        <Close className={classes.modalClose} />
                                    </Button>

                                    <h4 className={classes.modalTitle}>
                                        Indica las fechas a bloquear para <b>{this.state.actualService.name}</b>
                                    </h4>

                                </DialogTitle>
                                <DialogContent id="notice-modal-slide-description" className={classes.modalBody}>
                                    {/* CheckIn DatePicker */}
                                    <DateRangePicker
                                        numberOfMonths={1}
                                        // isOutsideRange={this.isBlocked}
                                        startDate={this.state.startDate}
                                        startDateId="start_date_to_block"
                                        endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                                        endDateId="end_date_to_block"
                                        onDatesChange={({ startDate, endDate }) => {
                                            // let maxBookableDate = _.chain(accommodation.bookings).filter((d)=>{
                                            //     return moment(d.start).isAfter(startDate, 'days');
                                            // }).orderBy((d)=>{ return moment(d.start);}).map('start').value();

                                            // this.setState({maxBookableDate: maxBookableDate[0]});
                                            this.setState({ startDate, endDate });

                                            // let minBookableDate = _.chain(accommodation.bookings).filter((d)=>{
                                            //     return moment(d.start).isBefore(startDate, 'days');
                                            // }).orderBy((d)=>{ return moment(d.end);}, ['desc']).map('end').value();
                                            //
                                            // this.setState({minBookableDate: minBookableDate[0]});

                                            // this.setState({ startDate, endDate });

                                        }} // PropTypes.func.isRequired,
                                        focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                        onFocusChange={focusedInput => this.setState({ focusedInput })}
                                        startDatePlaceholderText={"Inicio"}
                                        endDatePlaceholderText={"Fin"}
                                        displayFormat={'DD/MMM/YYYY'}
                                        showClearDates={true}
                                        hideKeyboardShortcutsPanel={true}
                                        minimumNights={0}
                                    />
                                    {/* End CheckIn DatePicker */}

                                    <hr/>

                                    {this.state.actualService.rooms.length > 0
                                        ? (
                                            <Table
                                                tableHead={
                                                    ["Habitación", "Descripción"]
                                                }
                                                tableData={
                                                    this.state.actualService.rooms.map((room, idx) => {
                                                        return [
                                                            <Checkbox
                                                                checked={this.state.checked.indexOf(idx) !== -1}
                                                                tabIndex={-1}
                                                                onClick={() => this.handleToggle(idx)}
                                                                checkedIcon={<Check className={classes.checkedIcon} />}
                                                                icon={<Check className={classes.uncheckedIcon} />}
                                                                classes={{
                                                                    checked: classes.checked
                                                                }}
                                                            />,
                                                            room.name,
                                                            room.description
                                                        ];
                                                    })
                                                }
                                            />
                                        )
                                        : null
                                    }
                                </DialogContent>
                                <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
                                    <Button onClick={() => this.blockDates()} color="success">
                                        Bloquear
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            {/* NOTICE MODAL END */}

                            <Table
                                tableHead={
                                    serviceType === 'tours'
                                        ? ["Nombre", "Sitio", "Precio ($COP)", "Acciones"]
                                        : ["Nombre", "Sitio", "Tipo de alojamiento", "Acciones"]
                                }
                                tableData={ tableData }
                                customCellClasses={[
                                    classes.textCenter,
                                    classes.textRight,
                                    classes.textRight
                                ]}
                                customClassesForCells={[0, 4, 5]}
                                customHeadCellClasses={[
                                    classes.textCenter,
                                    classes.textRight,
                                    classes.textRight
                                ]}
                                customHeadClassesForCells={[0, 4, 5]}
                            />
                        </GridItem>
                    </GridContainer>

                </div>
            </div>
        );
    }
}

SectionTable.propTypes = {
    blockServiceDates: PropTypes.func.isRequired,
    ownersReducer: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    ownersReducer: state.ownersReducer,
    errors: state.errors
});

export default connect(mapStateToProps, { blockServiceDates })( withStyles(style)(SectionTable) );



// WEBPACK FOOTER //
// ./src/views/Management/SectionTable.jsx